import {_warning, getBorderColor, message, resizeToBottomCorner, showLoading} from "./main";
import {initCopyToClipboard} from "./main_misc";
import {show} from "./main_modal";
import {defaultErrCallback, defaultJsonCallback} from "./main_callbacks";
import {getFunction} from "./main_system";
import {addRemoteTab, removeTab, showTab} from "./main_tabs";
import {msgResolve} from "./main_resolver";
import {reloadCurrent} from "./main_page";
import {submit} from "./main_form";
import {getLocale} from "./main_locale";
import {createCharts} from "./main_charts";


export const TINYMCE_CONFIG = {
	selector: '.tinymce',
	automatic_uploads: true,
	browser_spellcheck: true,
	extended_valid_elements: 'script[language|type|src],i[class]',
	plugins: [
		"advlist autolink lists link image charmap print preview anchor",
		"searchreplace visualblocks code fullscreen",
		"insertdatetime media table contextmenu paste image imagetools textcolor hr"
	],
	toolbar: "insertfile undo redo | styleselect | bold italic forecolor | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link unlink image imagetools code | removeformat",
	content_css: "/dres/css/built.css",
	link_class_list: [
		{title: 'basic', value: ''},
		{title: 'button main', value: 'btn btn-main'},
		{title: 'button main & modal', value: 'btn ptx-show-modal btn-main'},
		{title: 'button new', value: 'btn btn-new'},
		{title: 'button new & modal', value: 'btn ptx-show-modal btn-new'},
		{title: 'button menu', value: 'btn btn-menu'},
		{title: 'button menu & modal', value: 'btn ptx-show-modal btn-menu'},
	],
	// Gets list of available public files of current reseller and offer them to user in dialog for insert image.
	image_list: '/dres/files.json'
};

/**
 * Create fully qualified url from given one
 * @alias Ptx.url
 * @url - may start with /positrex, or with #
 * @isLink - user for hrefs, append #
 */
export function getUrl(urlPath, isLink) {
	if (urlPath.startsWith('#')) {
		urlPath = urlPath.substring(1);
	}
	var completeUrl = urlPath;
	if (urlPath.startsWith(Ptx.baseUrl + '/')) {

	} else {
		completeUrl = Ptx.baseUrl + urlPath;
	}
	return completeUrl;
}

/**
 * Show modal after click event
 * @alias Ptx.fn.initShowModal
 * @param ctx
 */
export function initShowModal(ctx) {
	let $modal = $('a.ptx-show-modal', ctx);
	$modal.off('click');

	$modal.on('click', function (e) {
		e.preventDefault();
		var btn = $(this);
		var size = btn.data('ptx-modal-size');
		var cssClass = btn.data('ptx-modal-cssclass');
		var msg = btn.data('confirm-msg');
		var url = btn.attr('href');

		initModal(url, size, msg, cssClass);
	});
}


/**
 * Create modal and show
 * @alias Ptx.fn.initModal
 * @alias Ptx.fn.initModal
 * @param url
 * @param size
 * @param msg
 * @param cssClass
 */
export function initModal(url, size, msg, cssClass) {
	var modalSize = size ? size : 'modal-xl';
	if (msg) {
		if (!confirm(msg))
			return;
	}
	show('modal-form', getUrl(url), {
		ptxSize: modalSize,
		cssClass: cssClass,
		backdrop: 'static'
	});
}

/**
 * call url that make some action, and reload current page button - jQ object of
 * link
 * @alias Ptx.fn.callUrl
 */
export function callUrl(btn) {
	var urlPath = getUrl(btn.attr('href'));
	var callback = defaultJsonCallback;
	if (btn.data('callback')) {
		callback = getFunction(btn.data('callback'), window);
	}
	openWithParams(urlPath, "GET", {
		sm_dec: 'none'
	}, callback);
}

/**
 * jquery append element in 'ctx' parent with 'data'
 * @alias Ptx.fn.appendData
 * @param ctx
 *          selector
 * @param data
 *          to place
 */
export function appendData(ctx, data) {
	$(ctx).append(data);
}

/**
 * Remove DOM element as defined in data attribute of ele
 * @alias Ptx.fn.removeDom
 * @param ele -
 *          element with data-selector attribute with jQeury selector to remove
 */
export function removeDom(ele) {
	var sel = $(ele).data('selector');
	var item = $(sel);
	item.remove();
}

/**
 * s Init components for summary datatables only
 * @alias Ptx.fn.initSummaryComponents
 * @param ctx
 */
export function initSummaryComponents(ctx) {
	var $ctx = $(ctx);
	initShowModal($ctx);
	actionCall($ctx);
	initSendSmsLink($ctx);

    let scrollY = sessionStorage.getItem('contentScrollTop');

    if (!scrollY) {
        sessionStorage.setItem('contentScrollTop', '0');
    }

    window.addEventListener('scroll', function (_) {
        sessionStorage.setItem("contentScrollTop", this.scrollY.toString());
    })

	alignDropdown($ctx);
}

/**
 * init common components for modal, tabs and pages ,like datepicker or remote url
 * @param ctx where to init
 * @alias Ptx.fn.initComponents
 */
export function initComponents(ctx) {
	var $ctx = $(ctx);

	var dpSettings = {
		autoclose: true,
		language: getLocale('datepicker'),
		todayHighlight: true,
	};
	if (isRtl()) {
		Object.assign(dpSettings, {
			rtl: true
		});
	}

	// * P,M - init datepicker
	$('.date-picker-btn', $ctx).on('click', function () {
		// * P,M - init datepicker
		var $input = $(this).parent().find('.date-picker-input');
		$input.datepicker(dpSettings);
		$input.focus();
	});

	$('.date-picker', $ctx).each(function () {
		var settings = dpSettings;
		var dp = $(this);

        if (dp.hasClass('month-format')) {
            settings.format = Ptx.getMsg('format.dateMonth.js').toLowerCase();
            settings.minViewMode = 1;
        }

		if (dp.hasClass('day-format')) {
			settings.format = Ptx.getMsg('format.date.js').toLowerCase();
			settings.minViewMode = 0;
		}

        if (dp.hasClass('multiselect-date')) {
            settings.autoclose = false;
            settings.multidate = true;
            settings.multidateSeparator = ',';
        }

		dp.datepicker(settings);

		if (!dp.val() && dp.hasClass('default-today')) {
			dp.datepicker('update', new Date());
		}
	});

	charts(ctx);

	// Init colorpicker
	$('.color-picker', $ctx).each(function() {
		initColorPicker($(this));
	})

	Ptx.fn.initTooltips(ctx);
	initEnter(ctx);

	// * P,M - multiselect combobox
	var multiselectSettings = {
		enableHTML: true,
		numberDisplayed: 1,
		includeSelectAllOption: true,
		enableFiltering: true,
		includeFilterClearBtn: false,
		maxHeight: 600,
		allSelectedText: Ptx.getMsg('multiselect.allSelected'),
		selectAllText: Ptx.getMsg('common.choose.all'),
		nSelectedText: Ptx.getMsg('multiselect.nSelected'),
		nonSelectedText: Ptx.getMsg('multiselect.noneSelected'),
		filterPlaceholder: Ptx.getMsg('common.btn.search')
	};
	$('.ptx-simple-multiselect', $ctx).multiselect(multiselectSettings);
	$('.ptx-simple-multiselect-right', $ctx).multiselect(
		$.extend({}, multiselectSettings, {
			dropRight: true,
			buttonWidth: '150px',
		})
	);

	// * P,M - set height by window minus attribute
	$('[data-full-height]', $ctx).each(function () {
		fullHeight($(this), $(this).data('full-height'))
	});


	// TODO move to modal init
	// * M button to be opened in modal tab
	$('a.ptx-open-in-new-tab', $ctx).on('click', function (e) {
		e.preventDefault();
		var btn = $(this);
		var url = btn.attr('href');
		var tabId = btn.data('tab-id');
		var tabName = btn.data('tab-name');
		var modalTab = btn.hasClass('ptx-modal-tab');
		var autoClose = btn.hasClass('ptx-auto-close-tab');
		var css = false;
		if (modalTab) {
			css = 'ptx-modal-tab';
		}
		if (autoClose) {
			css = 'ptx-auto-close-tab';
		}
		ctx = Ptx.modal.ctx.window; // only in modal window there will be tab
		let tabLink = $('a[href="#' + tabId + '"]', ctx);
		if(tabLink.length > 0) {
			removeTab(tabId, ctx, -1);
		}
		addRemoteTab(tabId, {
			tabName: tabName,
			url: url,
			cssClass: css
		}, ctx);
		Ptx.modal.ctx.window.scrollTop(0);

		// leave confirm tab on leave, and close it on confirm
		var tab = $('a[href="#' + tabId + '"]', ctx)
		if (modalTab) {
			tab.on('hide.bs.tab', function (e) {
				e.preventDefault();
				Ptx.confirm(Ptx.getMsg('confirmCloseTab'), function (msg) {
					if (msg) {
						removeTab(tabId, ctx, -1);
						$(e.relatedTarget).tab('show');
					}
				});
			});
		}
		if (autoClose) {
			var tabz = Ptx.modal.ctx.tab;
			tab.on('hide.bs.tab', function (e) {
				if (tabz && tabz.onunload) {
					tabz.onunload(ctx);
				}
				removeTab(tabId, ctx, -1);
			});
		}
		Ptx.fn.initTab(ctx);
		showTab(tabId, ctx);
	});

	// * P,M - trigger that removes some DOM element (jQ selector in data-selector
	// attribute
	$('a.ptx-remove-dom', $ctx).on('click', function (e) {
		e.preventDefault();
		removeDom($(this));
	});

	reloadContentAll($ctx);
	initCheckGroup($ctx);
	initChosen($ctx);
	initSlideBtn(ctx);
	msgResolve($ctx);
	initShowAllChild($ctx);
	initShowChild($ctx);
	initSummaryComponents($ctx);
	alignDropdown($ctx);

	// add shift value into page filter and submit filter form
	$('.shift', $ctx).on('click', function (e) {
		e.preventDefault();
		var shift = $(this).data('ptx-shift');
		$('input[name="shift"]', ctx).val(shift);
		reloadCurrent();
	})

	// add shift value into page filter and submit filter form
	$('.shift-unit', $ctx).on('click', function (e) {
		e.preventDefault();
		var shift = $(this).data('ptx-shift');
		var index = $("#filterUnitId").prop('selectedIndex');
		$("#filterUnitId").prop('selectedIndex', index + shift);
		reloadCurrent();
	})

	// * P,M - simple ajax form submit that returns JsonDlgView with message
	$('.ptx-call-submit', $ctx).on('click', function (e) {
		e.preventDefault();
		var form = $(this).closest('form');
		submit(form, function (data, svr) {
			if (svr.isJson && data.submitFinal) {
				message(data.finalMsg);
			}
		});

	});

	$('.tags-input', $ctx).tagsinput(
			{itemValue: 'id', itemText: 'text', tagClass: 'label label-info font-big-i'}
	);
	$('.bootstrap-tagsinput').css('width', '100%');//not nice ! but they have weird css

	initCopyToClipboard();

	$('.ptx-address-suggest', $ctx).mapWhisperer();

	$('.icon-select', $ctx).selectpicker();
}

/**
 * align dropdown by window position
 * @alias Ptx.fn.alignDropdown
 * @param ctx
 */
export function alignDropdown(ctx) {
	$('.dropdown-menu', ctx).parent().on('show.bs.dropdown', function () {
		var t = $(this);
		var d = t.find(".dropdown-menu");
		var xDown = t.position().top + 100 + d.height();
		var wHeight = $(window).height() + $(window).scrollTop()

		if (xDown > wHeight) {
			d.css("margin-top", wHeight - xDown).css("margin-right", 30).addClass("alignByWindow");
		}
	})

	//remove added attribute 
	$('.dropdown-menu', ctx).parent().on('hide.bs.dropdown', function () {
		var t = $(this);
		var d = t.find(".dropdown-menu");
		if (d.hasClass("alignByWindow")) {
			d.removeClass("alignByWindow");
		}
	})
}

/**
 * create a new charts from prepare div data
 * @alias Ptx.fn.charts
 * @param ctx
 */
export function charts(ctx) {
	var $graphs = $('.ptx-render-graph:not(.done)', ctx);

	if ($graphs.length === 0) {
		return; // If no graph found, exit the function
	}

	var processGraph = function ($this) {
		var statType = $this.data('stat-type');
		var hash = $this.data('hash');
		var refreshChart = $this.data('refresh');
		var urlPath = "";

		if (statType) {
			urlPath = '/statistics/data/charts/' + statType + '.json';
		} else if (hash) {
			urlPath = '/public/statistics/data.json';
		} else {
			urlPath = $this.data('url');
		}

		var boxClass = null;
		if ($this.data('class')) {
			boxClass = $this.data('class');
		}
		var heightRatio = null;
		if ($this.data('heightratio')) {
			heightRatio = $this.data('heightratio');
		}
		var identify = "";
		if ($this.data('identify')) {
			identify = $this.data('identify');
		}
		var tooltipValue = "";
		if ($this.data('tooltipValue')) {
			tooltipValue = $this.data('tooltipValue');
		}
		var datax = {
			'unitId': $this.data('unit-id'),
			'client': $this.data('client-id'),
			'from': $this.data('from'),
			'to': $this.data('to'),
			'graphPeriodByData': $this.data('graph-period-by-data'),
			'limit': $this.data('limit'),
			'params': $this.data('params'),
			'trackId': $this.data('track-id'),
			'hash': $this.data('hash'),
			'providerParams': $this.data('provider-params')
		}

		/** @see GraphTag.java#getGraphPeriodByData() */
		if (!$this.data('graph-period-by-data')) {
			var dateFrom = $this.data('from');
			var dateTo = $this.data('to');
		}

		var loadData = function () {
			const showLoader = !datax.providerParams;
			if (showLoader) {
				showLoading(true, 'chart', null);
			}
			openWithParams(getUrl(urlPath), 'POST', datax, function (data) {
				var options = {
					data: {
						charts: data.charts
					},
					boxClass: boxClass,
					heightRatio: heightRatio,
					identify: identify,
					tooltipValue: tooltipValue,
					dateFrom: dateFrom,
					dateTo: dateTo
				};
				createCharts(options);

				if (data.charts.length === 1) {
					processNextGraph();
				} else if (refreshChart) {
					refresh(refreshChart, processNextGraph);
				}
				if (Ptx.onDataLoaded)
					Ptx.onDataLoaded()
			}, {
				locationName: "chart",
				showLoader: showLoader
			})
		}

		loadData();
		$this.addClass('done');
	};

	var currentIndex = 0;

	var processNextGraph = function () {
		if (currentIndex < $graphs.length) {
			processGraph($graphs.eq(currentIndex));
			currentIndex++;
		}
	};

	processNextGraph();
}

/**
 * This function initializes a color picker, transforming the regular select with hex codes into colorful squares.
 * @param select - the original select tag containing colors
 * @alias Ptx.fn.initColorPicker
 */
export function initColorPicker(select) {
	var colorpickerMenu = $('<div class="colorpicker-menu" id="customColorPicker"></div>');
	var colorpickerContainer = $('<div class="colorpicker-container"></div>');

	select.hide();
	// Populate color squares based on the original select options
	select.find('option').each(function () {
		var colorSquare = $('<div class="color-square"></div>');
		colorSquare.css('background-color', $(this).val());
		colorSquare.attr('data-color', $(this).val());
		colorpickerMenu.append(colorSquare);
	});

	// Set the selected color when clicking on a color square & trigger original select change
	colorpickerMenu.on('click', '.color-square', function () {
		var selectedColor = $(this).data('color');
		select.val(selectedColor);
		select.trigger('change');
		$(colorpickerContainer).css('background-color', select.val());
		colorpickerMenu.hide();
	});

	// Place the custom color picker to DOM
	select.after(colorpickerContainer);
	$(colorpickerContainer).css('background-color', select.val());
	select.after(colorpickerMenu);

	// Show/hide the custom color picker menu on click
	$(colorpickerContainer).click(function () {
		colorpickerMenu.toggle();
	});
}

/**
 * @alias Ptx.fn.initBatchActionCall
 * opts - object :
 * 	checkboxName - name of checkbox with ids, default 'unitId',
 *  idParamName - name of param to url, default 'unitId',
 *  selector - class to search for in link to activate this, defaults to 'ptx-batch-action'
 *  httpMethod - defaults to GET
 *  callback - function to be called when batch action is triggered
 */
export function initBatchActionCall(ctx, opts) {
	var opts = opts ? opts : {};
	var selector = opts.selector ? opts.selector : '.ptx-batch-action';
	var modalSize = opts.modalSize ? opts.modalSize : 'modal-full';
	$(selector, ctx).on('click', function (e) {
		e.preventDefault();

		var checkName = opts.checkboxName ? opts.checkboxName : 'unitId';
		var idParamName = opts.idParamName ? opts.idParamName : 'unitId';
		var httpMethod = opts.httpMethod ? opts.httpMethod : 'GET';

		var urlPath = $(this).attr('href');
		var unitId = $("input[name=" + checkName + "]:checkbox:checked").map(function () {
			return $(this).val();
		}).get();

		if (unitId.length == 0) {
			_warning(Ptx.getMsg('common.warn.itemsNotSelected'));
		} else {
			var params = {};
			params[idParamName] = unitId;

			if (opts['callback']) {
				opts.callback(urlPath, idParamName, unitId);
				return;
			}

			if (urlPath.contains(".json")) {
				confirmedAction($(this), function (linkUrl) {
					openPtx(urlPath, httpMethod, params, defaultJsonCallback, {});
				});


			} else {
				show('modal-form', getUrl(urlPath), {
					backdrop: 'static',
					params: params,
					ptxSize: modalSize,
					method: httpMethod
				});
			}
		}
	});
}

/**
 * action that can be confirmed if data-confirm-msg is present
 * @alias Ptx.fn.actionCall
 * @param ctx
 */
export function actionCall(ctx) {
	$('a.ptx-call-action', ctx).off('click.callAction').on('click.callAction', function (e) {
		e.preventDefault();
		confirmedAction($(this), callUrl);
	});
}

/**
 * Helper for link (button) with confirm-msg that shows confirmation and calls
 * callback if confirmed, or do nothing otherwise
 * @alias Ptx.fn.confirmedAction
 * @param link
 * @param callback
 */
export function confirmedAction(link, callback) {
	var msg = link.data('confirm-msg');
	if (msg) {
		Ptx.confirm(msg, function (ok) {
			if (ok) {
				callback(link);
			}
		});
	} else {
		callback(link);
	}
}

/**
 * show all child in datatable
 * @alias Ptx.fn.initShowAllChild
 * @param ctx
 */
export function initShowAllChild(ctx) {
	$('.do-showAllChild', ctx).off('click.showAllChild').on('click.showAllChild', function (e) {
		e.preventDefault();
		var obj = $(this);

		showHideAllChild(obj);
	});
}

/**
 * show all child in datatable
 * @alias Ptx.fn.initShowChild
 * @param ctx
 */
export function initShowChild(ctx) {
	$('.do-showChild', ctx).off('click.showChild').on('click.showChild', function (e) {
		e.preventDefault();
		var obj = $(this);

		showHideChild(obj);
	});
}

/**
 * show or hide all child in datatable
 * @alias Ptx.fn.showHideAllChild
 * @param obj
 */
export function showHideAllChild(obj) {
	if ($(obj).data('show-child') == false) {
		showHideSubRowsBtn(obj);
		$('.ptx-table').find('.btn-more').has('i.fa-plus').each(function () {
			showHideChild(this);
		});
	} else {
		showUnfoldSubRowsBtn(obj);
		$('.ptx-table').find('.btn-more').has('i.fa-minus').each(function () {
			showHideChild(this);
		});
	}
}

/**
 * show or hide child in datatable
 * @alias Ptx.fn.showHideChild
 * @param obj
 */
export function showHideChild(obj) {
	var rowId = $(obj).parent().closest('tr').attr('id');
	
	var isDefaultHidden = $(obj).data('show-child-default-is-hidden');
	if (isDefaultHidden === undefined) { // if missing defaults to hiding rows...
		isDefaultHidden = true;
	}
	
	var sessionName = $(obj).data('show-child-session-name');
	if (sessionName === undefined) { // if missing default to 'child'
		sessionName = 'child';
	}

	if ($(obj).data('show-child') == false) {
		showHideSubRowsBtn(obj);
		$("tr[data-child-of='" + rowId + "']").removeClass('hidden');
		
		if (isDefaultHidden) {
			addSession(sessionName, rowId);
		} else {
			removeSession(sessionName, rowId);
		}
	} else {
		showUnfoldSubRowsBtn(obj);
		$("tr[data-child-of='" + rowId + "']").addClass('hidden');
		
		if (isDefaultHidden === false) {
			addSession(sessionName, rowId);
		} else {
			removeSession(sessionName, rowId);
		}
	}
}

/**
 * Init links for sending SMS to unit
 * @alias Ptx.fn.initSendSmsLink
 * @param ctx
 */
export function initSendSmsLink(ctx) {
	$('.ptx-send-sms', ctx).on('click', function (e) {
		e.preventDefault();
		var lnk = $(this);
		var unitId = lnk.data('unit-id');
		var template = lnk.data('sms-template');
		var isUnitGDSP = lnk.data('gdsp');
		var params = {
			unitId: unitId,
			smsTemplateType: template
		}
		Ptx.confirm(Ptx.getMsg('sendConfirm.' + isUnitGDSP + '.' + template), function (msg) {
			if (msg) {
				openWithParams(getUrl("/vehicle/SMS/send.json"), "POST", params, function (data, srv) {
					if (data.smsSent) {
						message(data.message);
					} else {
						_warning(data.message);
					}
				});
			}
		});
	});
}

/**
 * Shows the button to hide the sub-items in datatable and sets the value of object data under key 'show-child' to true.
 * @alias Ptx.fn.showHideSubRowsBtn
 * @param obj
 */
export function showHideSubRowsBtn(obj) {
	$(obj).children('i').removeClass('fa-plus').removeClass('text-success');
	$(obj).children('i').addClass('fa-minus').addClass('text-danger');
	$(obj).data('show-child', true);
}

/**
 * Shows the button to unfold the sub-items in datatable and sets the value of object data under key 'show-child' to false.
 * @alias Ptx.fn.showUnfoldSubRowsBtn
 * @param obj
 */
export function showUnfoldSubRowsBtn(obj) {
	$(obj).children('i').removeClass('fa-minus').removeClass('text-danger');
	$(obj).children('i').addClass('fa-plus').addClass('text-success');
	$(obj).data('show-child', false);
}

/**
 * return localStorage json of define name
 * @alias Ptx.fn.getSession
 * @param name
 */
export function getSession(name) {
	return JSON.parse(localStorage.getItem(name));
}

/**
 * add new data to define session name
 * @alias Ptx.fn.addSession
 * @param name
 * @param value
 */
export function addSession(name, value) {
	var session = [];
	var storage = getSession(name);
	if (storage != null) {
		session = storage;
	}
	// Pushes the value and update array in storage only if the value is not already present in the array.
	// If the value is already present, then no action is needed because the value is already present in the array.
	if (!session.includes(value)) {
		session.push(value);
		localStorage.setItem(name, JSON.stringify(session));
	}
}

/**
 * set new data to define session name
 * @alias Ptx.fn.setSession
 * @param name
 * @param value
 */
export function setSession(name, value) {
	localStorage.setItem(name, JSON.stringify(value));
}

/**
 * remove some data from define session name
 * @alias Ptx.fn.removeSession
 * @param name
 * @param value
 */
export function removeSession(name, value) {
	var session = [];
	var storage = getSession(name);
	if (storage != null) {
		session = storage;
		session.splice(session.indexOf(value), 1);
	}
	localStorage.setItem(name, JSON.stringify(session));
}

/**
 * add and set cookie
 * @alias Ptx.fn.setCookie
 * @param cname
 * @param cvalue
 * @param exdays
 */
export function setCookie(cname, cvalue, exdays) {
	var d = new Date();
	d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
	var expires = "expires=" + d.toUTCString();
	document.cookie = cname + "=" + cvalue + "; " + expires;
}

/**
 * get name from cookie
 * @alias Ptx.fn.getCookie
 * @param cname
 */
export function getCookie(cname) {
	var name = cname + "=";
	var ca = document.cookie.split(';');
	for (var i = 0; i < ca.length; i++) {
		var c = ca[i];
		while (c.charAt(0) == ' ')
			c = c.substring(1);
		if (c.indexOf(name) == 0)
			return c.substring(name.length, c.length);
	}
	return "";
}

/**
 * reload all content in whole context
 * @alias Ptx.fn.reloadContentAll
 * @param ctx
 */
export function reloadContentAll(ctx) {
	// * P,M - to this element load remote url from data-href
	$('.ptx-remote-content', ctx).each(function () {
		reloadContent($(this));
	});
	$('.ptx-remote-content-no-loader', ctx).each(function () {
		reloadContent($(this), false, false);
	});
}

/**
 * load content into element, that have data-href attribute with url /positrex/aa/data.htm url
 * @alias Ptx.fn.reloadContent
 * @param ele - element to load
 * @param clearElement - clear content of ele before set new? Default value is true (original behaviour).
 * @param useLoader - use loader animation while refreshing content of ele? Default value is true (original behaviour).
 */
export function reloadContent(ele, clearElement, useLoader) {
	const url = ele.data('href');
	if (clearElement === undefined) {
		clearElement = true;
	}
	if (useLoader === undefined) {
		useLoader = true;
	}
	if (clearElement) {
		ele.html('');
	}

	openWithParams(url, "GET", {
		sm_dec: 'none'
	}, function (data, srv) {
		// if (srv.isHtml) {
		ele.html(data);
		initComponents(ele);
		// }
	}, {
        showLoader: useLoader
	});
}

/**
 * init chosen select boxes by class
 * @alias Ptx.fn.initChosen
 * @param ctx
 */
export function initChosen(ctx) {
	var config;

	if (isDesktop()) {
		config = {
			'.chosen-select': {
				width: "100%",
				disable_search_threshold: 10
			},
			'.chosen-select-deselect': {
				width: "100%",
				allow_single_deselect: true
			},
			'.chosen-select-no-single': {
				width: "100%",
				disable_search_threshold: 10
			},
			'.chosen-select-no-results': {
				width: "100%",
				no_results_text: 'Oops, nothing found!'
			},
			'.chosen-select-width': {
				width: "100%"
			}
		}
	}

	for (var selector in config) {
		if (isRtl()) {
			$(selector).addClass('chosen-rtl');
		}

		$(selector).chosen(config[selector]);
	}

	$('.chosen-container', ctx).on('click', function () {
		var ww = $(window).width();
		var $this = $(this);
		var drop = $this.find('.chosen-drop');
		var width = drop.width();

		var margin = $this.position().left;
		var wm = width + margin;

		if (ww < wm) {
			var widthSelect = $this.width();
			var left = widthSelect - width - 2;
			drop.css('margin-left', left)
		}
	})

	$('.ptx-multi-select-all, .ptx-multi-select-none').on('click', function (e) {
		e.preventDefault();
	});
}

export function initSlideBtn(ctx) {
	var $sliderContainer = $(".btn-slide-container", ctx);

	var buttonCount = $sliderContainer.find("button").length;
	var SLIDER_WIDTH = 100 / buttonCount;

	$sliderContainer.find("button").each(function (index) {
		$(this).on("click", function () {
			slideBg(index);
			setActiveButton($(this));
		});
	});

	const $firstButton = $sliderContainer.find("button").first();
	setActiveButton($firstButton);

	function slideBg(n) {
		let bgOffset = SLIDER_WIDTH * n;
		$sliderContainer.css("--bg-offset", bgOffset + "%");
	}

	function setActiveButton($clickedButton) {
		$sliderContainer.find("button").removeClass("active");
		$clickedButton.addClass("active");
	}
}


/**
 * @alias Ptx.fn.initSavingCollapseById
 * @param id
 * @param key
 * @param callback
 */
export function initSavingCollapseById(id, key, callback) {
	const selector = "#" + id;

	$(selector).on('shown.bs.collapse', function () {
		addSession(id, key);
		if (typeof callback === 'function') {
			callback();
		}
	});

	$(selector).on('hidden.bs.collapse', function () {
		removeSession(id, key);
		if (typeof callback === 'function') {
			callback();
		}
	});

	const session = getSession(id);
	if (session != null && session.includes(key)) {
		$(selector).collapse('show');
	}
}

/**
 * init mobile menu functionality
 * @alias Ptx.fn.initMobileMenu
 */
export function initMobileMenu() {
	$('#ptx-mobile-menu a').on('click', function (e) {
		if ($(this).hasClass('ptx-no-reload')) {
			e.preventDefault();
		}
		$('#ptx-mobile-menu li').removeClass('open');

		$(this).parents('li').addClass('open');
	});
}

/**
 * open page with given http method, and specified params, not suitable for file
 * upload!! for this use Ptx.form.submit
 * @alias Ptx.fn.openWithParams
 * @param url
 * @param method (get, post)
 * @param params = what to send
 * @param callback(data, srv, requestParams) = after response returns
 * @param opts
 *          aditional parameters (contentType,processData for upload), loader -
 *          id of loader image, errCallback(xhr, textStatus, error, url) -
 *          custom error handler as of jQuery $.ajax
 */
export function openWithParams(url, method, params, callback, opts) {
	let loader = '#loader';
    let showLoader = true;
	let locationName = 'page';
	let errClb = defaultErrCallback;
	let forceReload = false;

	let csrfToken = $("meta[name='_csrf']").attr("content");
	let csrfHeader = $("meta[name='_csrf_header']").attr("content");

	if (opts) {
		if (typeof opts.loader != 'undefined')
			loader = opts.loader;
        if (typeof opts.showLoader != 'undefined')
            showLoader = opts.showLoader;
		if (typeof opts.errCallback != 'undefined')
			errClb = opts.errCallback;
		if (typeof opts.forceReload != 'undefined')
			forceReload = opts.forceReload;
		if (typeof opts.locationName != 'undefined')
			locationName = opts.locationName;
	}

	let ajaxOpts = {
		cache: false,
		type: method,
		url: url,
		data: params,
		beforeSend: function(xhr) {
			xhr.setRequestHeader(csrfHeader, csrfToken);
			if (showLoader) {
				showLoading(true, locationName, loader);
			}
		},
	};

	if (opts) {
		if (typeof opts.contentType != 'undefined')
			ajaxOpts['contentType'] = opts.contentType;
		if (typeof opts.processData != 'undefined')
			ajaxOpts['processData'] = opts.processData;
	}
	return $.ajax(ajaxOpts).done(function (data, status, xhr) {
		if (showLoader) {
			showLoading(false, locationName, loader);
		}

		if (callback) {
			callback(data, createServerInfo(status, xhr, url, forceReload, params));
		}
	}).fail(function (xhr, textStatus, error) {
		errClb(xhr, textStatus, error, url, loader, params);
	});
}

/**
 * @alias Ptx.fn.downloadFile
 * @param url endpoint that returns file for download
 * @param parameters
 */
export function downloadFile(url, parameters) {
	fetch(url, {
		headers: {
			[$('meta[name="_csrf_header"]').attr('content')]: $('meta[name="_csrf"]').attr('content')
		},
		method: 'POST',
		body: JSON.stringify({parameters}),
		credentials: 'include'
	})
	.then(res => {
		let contentDisposition = res.headers.get('content-disposition').split(';');
		let name = res.url.substring(res.url.lastIndexOf('/') + 1);
		for (let item of contentDisposition) {
			if (item.contains('fileName=')) {
				name = item.replace('fileName=', '').replaceAll('\"', '').trim();
				break;
			}
		}
		return ({fileName: name, blob: res.blob()});
	})
	.then(async ({fileName, blob}) => {
		let a = document.createElement('a');
		a.href = window.URL.createObjectURL(await blob);
		a.download = fileName;
		a.click();
		a.remove();
	})
	.catch(err => Ptx.fn.jsonMessageBoxCallback(err))
}

/**
 * Same as Ptx.fn.openWithParams, but prepends application context to url
 * (/positrex) so it can be used for internal positrex calls only
 * @alias Ptx.fn.openPtx
 * @url - with leading slash, eg. /admin/user.htm
 */
export function openPtx(urlPath, method, params, callback, opts) {
	openWithParams(getUrl(urlPath), method, params, callback, opts);
}

/**
 * init checkbox groups with master checkbox that can handle group check and
 * uncheck based on master value class="ptx-check-group-master"
 * data-ptx-group="group1" for master checkbox class="ptx-check-group"
 * data-ptx-group="group1,group2" for slaves checkboxes, slaves can have more
 * groups
 * @alias Ptx.fn.initCheckGroup
 * @param ctx
 */
export function initCheckGroup(ctx) {
	// * P,M - master checkbox for group checkbox (defined with data-ptx-group)
	const masterSel = 'input.ptx-check-group-master';
	// * P,M - slave checkboxes for group checkbox (defined with data-ptx-group)
	const slavesSel = 'input.ptx-check-group';

	var masterReference = document.querySelectorAll(".ptx-check-group-master");
	var slaveReference = []; // selection is made before check whole group by master

	function getMaster(group) {
		return document.querySelector(masterSel + '[data-ptx-group="' + group + '"]');
	}

	function getSlaves(group) {
		return $(slavesSel + '[data-ptx-group*="' + group + '"]');
	}

	// init master - when user click on master input
	$(masterSel, ctx).on('change', onMasterChange);

	// when user click on slave input
	$(slavesSel, ctx).on('change', onSlaveChange);

	// fill master checkboxes depend on slaves
	$(masterSel, ctx).each(function () {
		var master = $(this);

		if (! master.is(':checked')) {
			var group = master.data('ptx-group');
			var uncheckedSlaves = document.querySelectorAll(slavesSel + "[data-ptx-group*=\"" + group + "\"]:not(:checked)").length;
			master.prop('checked', uncheckedSlaves === 0);
		}
	});

	function onSlaveChange() {
		var groups = $(this).data("ptx-group").split(" ");
		for (var g = 0, gl = groups.length; g < gl; g++) {
			var master = getMaster(groups[g]);
			var count = document.querySelector(slavesSel + "[data-ptx-group*=\"" + groups[g] + "\"]:not(:checked)");
			master.checked = count === null;
		}
	}

	function onMasterChange() {
		var master = $(this);
		var mGroup = master.data('ptx-group');
		var isMasterChecked = master.is(':checked');
		var slaves = getSlaves(mGroup);
		var masterChecked = []; // masters to be filled after checkout

		slaves.prop("checked", isMasterChecked);

		/* lookup after slaves are checked */
		slaveReference = document.querySelectorAll(slavesSel + ":not(:checked)");

		slaves.each(function () {
			var $group = $(this).data("ptx-group").replace(mGroup, "").trim(); // next master group name
			/* check if dom reference have at least 1 element with same class = master is not possible to be checked */
			for (var sr = 0, srl = slaveReference.length; sr < srl; sr++) {
				if (slaveReference[sr].classList.contains($group) || slaveReference[srl - sr - 1].classList.contains($group)) {
					return masterChecked.push({group: $group, checked: false});
				}
			}
			masterChecked.push({group: $group, checked: true});
		});

		/* loop to check masters */
		for (var m = 0, ml = masterReference.length; m < ml; m++) {
			for (var n = 0, nl = masterChecked.length; n < nl; n++) {
				if (masterReference[m].dataset["ptxGroup"] === masterChecked[n].group) {
					masterReference[m].checked = masterChecked[n].checked;
				}
			}
		}
	}
}

/**
 * @alias Ptx.fn.interval
 * @param time
 * @param callback
 * @return interval variable
 */
export function interval(time, callback) {
	return setInterval(callback, time);
}

/**
 * @alias Ptx.fn.delay
 * @param time
 * @param callback
 * @return timeout variable
 */
export function delay(time, callback) {
	return setTimeout(callback, time);
}

/**
 * @alias Ptx.fn.clearDelay
 * @param time
 * @param callback
 * You ca used it only once on curent page! (bacouse Ptx.refresh variable)
 */
export function clearDelay(time, callback) {
	clearTimeout(Ptx.refresh);
	Ptx.refresh = delay(time, callback);
}

/**
 * @alias Ptx.fn.refresh
 * @param time
 * @param callback
 */
export function refresh(time, callback) {
	Ptx.page.ctx.refreshTime = time;
	clearRefresh();
	if (typeof callback === 'function') {
		Ptx.page.ctx.refresh = setInterval(function () {
			callback();
		}, time);
	} else {
		Ptx.page.ctx.refresh = setInterval(function () {
			reloadCurrent()
		}, time);
	}
}

/**
 * @alias Ptx.fn.clearRefresh
 */
export function clearRefresh() {
	if (typeof Ptx.page.ctx.refresh !== 'undefined') {
		clearInterval(Ptx.page.ctx.refresh);
	}
}

/**
 * @alias Ptx.fn.refreshArr
 * @param time
 * @param callback
 * @param key
 */
export function refreshArr(time, callback, key) {
	if (typeof Ptx.page.ctx.refreshTimeArr === "undefined") {
		Ptx.page.ctx.refreshTimeArr = [];
	}
	if (typeof Ptx.page.ctx.refreshArr === "undefined") {
		Ptx.page.ctx.refreshArr = [];
	}
	Ptx.page.ctx.refreshTimeArr[key] = time;
	clearRefreshArr(key);
	if (typeof callback === 'function') {
		Ptx.page.ctx.refreshArr[key] = setInterval(function () {
			callback();
		}, time);
	}
}

/**
 * @alias Ptx.fn.clearRefreshArr
 * @param key
 */
export function clearRefreshArr(key) {
	if (typeof Ptx.page.ctx.refreshArr[key] !== 'undefined') {
		clearInterval(Ptx.page.ctx.refreshArr[key]);
	}
}


/**
 * create server response object from status and xhr info in all callback is
 * available as srv object
 * @alias Ptx.fn.createServerInfo
 * @param textStatus
 * @param xhr - original XHR object from jquery
 * @param url
 * @param forceReload - if is requested to reload page after receiving response
 * @param requestParams - parameters for request sent
 * @returns server info object, see for details what is in there
 */
export function createServerInfo(textStatus, xhr, url, forceReload, requestParams) {
	if (typeof forceReload == 'undefined')
		forceReload = false;

	var ct = xhr.getResponseHeader("content-type") || "";
	var isJson = (ct.indexOf('json') > -1);
	var isHtml = (ct.indexOf('html') > -1);
	var result = {
		status: textStatus,
		xhr: xhr,
		ctype: ct,
		isJson: isJson,
		isHtml: isHtml,
		url: url,
		forceReload: forceReload,
		requestParams: requestParams

	};
	return result;
}

// MISC -----------------------------------
/**
 * color picker OLD, to DELETEs
 * @alias Ptx.fn.selectColor
 */
export function selectColor(color) {
	if (color != "") {
		$("[id^=\"color\"]").each(function (i) {
			this.style.border = "0";
		});
		$("#color" + color).css({
			"border": "2px dotted " + getBorderColor(color)
		});
		$("#color").val(color);
	}
	return false;
}

/**
 * color picker OLD, to DELETEs
 * @alias Ptx.fn.fullHeight
 */
export function fullHeight(obj, minus) {
	var winHeight = $(window).height();
	obj.height(winHeight - minus);
	return false;
}

/**
 * Check if it is mobile view
 * @alias Ptx.fn.isMobile
 */
export function isMobile() {
	return $(window).width() < 1260;
}

/**
 * Check if it is desktop view
 * @alias Ptx.fn.isDesktop
 */
export function isDesktop() {
	return $(window).width() >= 1260;
}

/**
 * Check if the device is in portrait mode
 * @alias Ptx.fn.isPortrait
 */
export function isPortrait() {
	return $(window).height() > $(window).width();
}

/**
 * Check if it is rtl view
 * @alias Ptx.fn.isRtl
 */
export function isRtl() {
	return Ptx.rtl === "true";
}

/**
 * callback only for desktop
 * @alias Ptx.fn.selectIfOnlyOne
 * @param element
 */
export function selectIfOnlyOne(element) {
	element.each(function () {
		var $that = $(this);
		var num = $that.find('option').length;
		if (num == 2) {
			var optVal = $that.find('option:last').val();
			if ($that.val() != optVal) {
				$that.val(optVal).change();
			}
		}
	});
}

/**
 * move element to start of element
 * @alias Ptx.fn.move
 * @param element
 * @param to
 */
export function move(element, to) {
	$(to).prepend($(element));
}

/**
 * move element to start of element
 * @alias Ptx.fn.moveEnd
 * @param element
 * @param to
 */
export function moveEnd(element, to) {
	$(to).append($(element));
}

/**
 * init submit by enter on form
 * @alias Ptx.fn.initEnter
 * @param ctx
 */
export function initEnter(ctx) {
	$('#ptx-filter-form', ctx).each(function () {
		var that = $(this);
		if (!that.hasClass("ptx-map-filter-form")) {
			that.find('input[type=text]:not(.chosen-search-input)', ctx).on('keydown', function (e) {
				if (e.which == 13) {
					that.submit();
				}
			});
		}
	});
}

/**
 * fixed filter
 * @alias Ptx.fn.fixedFilter
 * @param con
 *          condition true or false
 */
export function fixedFilter(con) {
	if (con) {
		$('#content').addClass('scroller-content');
		resizeToBottomCorner('.scroller-content', 'height');
	} else {
		$('#content').removeClass('scroller-content').removeAttr('style');
	}
}

/**
 * Parse float number from given string
 * @alias Ptx.fn.parseFloat
 * @param {string} str
 * @return zero if empty string or undefined param given
 */
export function parseFloatNumber(str) {
	if (typeof str == 'undefined' || str === "") {
		return null;
	}
	return parseDecimalNumber(str, numeral.localeData(Ptx.lang).delimiters);
}

/**
 * @alias Ptx.fn.formatGps
 * @param obj
 * @return {string}
 */
export function formatGps(obj) {
	var lon = obj.lon;
	var lat = obj.lat;
	if (!lon || !lat) return '?';
	var latSymbol = '';
	if (lat > 0) latSymbol = 'N';
	else if (lat < 0) latSymbol = 'S';
	var lonSymbol = '';
	if (lon > 0) lonSymbol = 'E';
	else if (lon < 0) lonSymbol = 'W';
	return Math.abs(lat).toFixed(6) + latSymbol + ' ' + Math.abs(lon).toFixed(6) + lonSymbol;
}

/**
 * Set given data (Java SelectItems in JSON) to $tgt
 * @alias Ptx.fn.setSelectItems
 */
export function setSelectItems($tgt, data) {
	$tgt.empty();
	$.each(data, function (ind, data) {
		$('<option>').val(data.id).text(data.optionText).appendTo($tgt);
	});
}

/**
 * Handles selection of reseller and client mostly in modal dialogs.
 * Function must be combined with prepend include of JSP part "/WEB-INF/jsp/ptx3/createClientsArray.jsp" that creates clientsArray variable.
 * @param ctx context
 * @param clientsArray array that contains created options elements for all available clients of all available resellers.
 *                     This array can be created via "/WEB-INF/jsp/ptx3/createClientsArray.jsp".
 * @param elementsIds object that contains ids of key html elements for this function.
 * 					  <ul>
 * 					      <li>targetResellerId - name of the "select" element with list of available resellers.
 * 					      If not present then default value "targetResellerId" will be used.
 * 					      </li>
 * 					      <li>targetClientId - name of the "select" element with list of available clients of selected reseller.
 * 					      If not present then default value "targetClientId" will be used.
 * 					      </li>
 * 					  </ul>
 */
export function handleResellerClientSelect(ctx, clientsArray,
										   elementsIds={
											   targetResellerId: "targetResellerId",
											   targetClientId: "targetClientId"}) {
	$('#' + elementsIds.targetResellerId, ctx).on('change', function() {
		updateClientSelect($(this).val());
	});

	function updateClientSelect(selectedResellerId) {
		const clientSelect = document.getElementById(elementsIds.targetClientId);
		if (clientSelect) {
			clientSelect.options.length = 0;
			// var clientsArray comes from "/WEB-INF/jsp/ptx3/createClientsArray.jsp"
			if (selectedResellerId > 0) {
				for (var i = 0; i < clientsArray[selectedResellerId].length; i++) {
					clientSelect.options[clientSelect.options.length] = clientsArray[selectedResellerId][i];
				}
			}
		}
	}
}

export function handlePanels() {
	const menuBtn = $("#open-sidenav");
	const filterBtn = $("#open-filter");
	const closeFilterBtn = $("#ptx-filter-close");
	const mapBtn = $("#open-map");
	const panelMenu = $("#panel-menu");
	const panelFilter = $("#page-filter");
	const panelMap = $("#panel-maps");
	const panelOverlay = $("#panel-menu-overlay");

	function openNav() {
		if (panelMenu.children().length > 0) {
			panelMenu.addClass("active");
			panelOverlay.addClass("active");
		}
	}

	function openFilter() {
		panelFilter.addClass("active");
		panelOverlay.addClass("active");
	}

	function openMap() {
		panelMap.addClass("active");
	}

	function closeNav(event) {
		event.preventDefault();
		if (panelMenu && panelMenu.hasClass("active")) {
			panelMenu.removeClass("active");
		}
		if (panelFilter && panelFilter.hasClass("active")) {
			panelFilter.removeClass("active");
		}
		if (panelMap && panelMap.hasClass("active")) {
			panelMap.removeClass("active");
		}
		panelOverlay.removeClass("active");
	}

	if (menuBtn) menuBtn.on("click", openNav);
	if (filterBtn) filterBtn.on("click", openFilter);
	if (mapBtn) mapBtn.on("click", openMap);
	if (closeFilterBtn) closeFilterBtn.on("click", closeNav);
	if (panelOverlay) panelOverlay.on("click", closeNav);
}

/**
 * Gets translated message from session storage.<br>
 * <b>WARNING:</b> Don't use on publicly accessible pages, because messages isn't loaded into session storage on that pages!
 * @param key
 * @returns {string} value for key. If value for key cannot be obtained then key is returned.
 * Never returns null, undefined or empty string, so these values does not have to tested in code.
 */
export function getMsg(key) {
	const value = sessionStorage.getItem(key);
	// Un-comment it for debug of async behaviour of loading messages into session storage.
	// console.log(new Date().toISOString() + " | getMsg(" + key + ")=" + value);
	return value != null ? value : key;
}

/**
 * Stores translated message into session storage.
 * @param key
 * @param value
 */
export function setMsg(key, value) {
	sessionStorage.setItem(key, value);
}


/**
 * DEV NOTES:
 * ptx-download - is CSS class which serves only as marker class for file download
 */